type EmployeeQuote = {
  name: string;
  quote: string;
  role: string;
};

// Careers page does not need translations
const QUOTES: EmployeeQuote[] = [
  {
    name: 'Joe O.',
    quote:
      "“AllTrails is the best company I've ever worked for, hands down. The focus on work/life balance and the excitement for the product are second to none.”",
    role: 'Program Manager, Parks Partnerships'
  },
  {
    name: 'Sydney C.',
    quote: "“I love working with such talented colleagues on a product that's bringing the magic of the outdoors to everyone. Come join us!”",
    role: 'Product Manager, Discovery'
  },
  {
    name: 'Jess W.',
    quote:
      '“Exploring, preserving, and respecting nature is so important and I love that our mission supports this for our customers as well as our teammates.”',
    role: 'Technical Program Manager'
  },
  {
    name: 'Matt G.',
    quote:
      "“The only place I've worked where the company practices what they preach and encourages employees to spend as much time outdoors as our users!”",
    role: ' Senior Marketing and Brand Designer'
  },
  {
    name: 'Eric L.',
    quote: '“The best work-life balance you can find! A wonderful company aspiring to connect people with the outdoors. My absolute DREAM job!”',
    role: 'Customer Support Specialist '
  },
  {
    name: 'Manon N.',
    quote:
      '“I love the flexibility to work remotely. My family is in France and I am very fortunate to be able to work from there at any time of the year.”',
    role: 'DI Operations Manager'
  },
  {
    name: 'Matt P.',
    quote:
      "“It's awesome to share a love for nature with my coworkers. Day-by-day we're making the outdoors more accessible & that makes me so stoked for the future.”",
    role: 'Senior Data Analyst'
  },
  {
    name: 'Andrew H.',
    quote:
      "“It's awesome to have joined a company full of people that are so passionate about the outdoors! It's kind of like turning a hobby into a career.”",
    role: 'Software Engineer, Frontend'
  },
  {
    name: 'Julia N.',
    quote:
      '“I love what I do, and for the first time in my life, I feel that my career is aligned with my life goals to help connect people with nature.”',
    role: 'Operations Associate'
  },
  {
    name: 'Emmeline W.',
    quote:
      '“Working at AllTrails is an invigorating experience, especially when working with talented individuals who are all about supporting each other, with the common vision to get others outside.”',
    role: 'Social Media Manager'
  }
];

export type { EmployeeQuote };
export { QUOTES };
